import styled from 'styled-components';
import { Button, IconButton } from 'ui/button';
import { MultiSelect } from 'ui/selectv2/MultiSelect';
import { spacing } from 'ui/theme';
import { colors } from 'ui/theme/colors';
import { smallShadow } from 'ui/theme/shadows';
import { caption } from 'ui/theme/typography';
import { pxToRem } from 'utils/convert';
import { TAG_SIZES } from './constants';

export const AddTagContainer = styled.div`
  align-items: center;
  display: flex;
  gap: ${spacing.eighth};
`;

export const IconTagWrapper = styled.div`
  display: flex;
`;

export const InlineTooltipContent = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: row;
  align-items: center;
  flex-wrap: wrap;
  gap: ${spacing.quarter};
`;

export const StyledActionButton = styled(Button)`
  margin-right: ${spacing.half};
  &:hover {
    cursor: pointer;
  }
`;

export const StyledIconButton = styled(IconButton)`
  && {
    path {
      stroke: ${colors.textSecondary};
    }
    :hover {
      cursor: pointer;
      background: none;
    }
  }
  margin: -${spacing.fiveEights} -${spacing.threeQuarter} -${spacing.fiveEights} -${spacing.quarter};
`;

export const TagGroupActionButtons = styled.div`
  margin-top: ${spacing.base};
`;

export const TagGroupContentWrapper = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: row;
  align-items: center;
  flex-wrap: wrap;
`;

export const TagGroupWrapper = styled.div`
  border-radius: ${spacing.quarter};
`;

export const TagGroupEditWrapper = styled.div`
  width: 100%;
`;

export const TagGroupSelectContentWrapper = styled.div`
  border-radius: ${spacing.quarter};
  padding: ${spacing.half};
  max-width: ${pxToRem(450)};
`;

export const TagWrapper = styled.div`
  border: ${pxToRem(1)} solid ${colors.grey15};
  border-radius: ${pxToRem(100)};
  ${caption};
  color: ${colors.grey80};
  margin: ${spacing.quarter} ${spacing.quarter};
  display: inline-flex;
  align-items: center;
  padding: ${spacing.threeEights};

  &[data-size=${TAG_SIZES.SMALL}] {
    padding: ${spacing.eighth};
  }

  &[data-is-clickable="true"] {
    background: ${colors.backgroundTertiary};
  }

  &:hover {
    box-shadow: none;

    &[data-has-box-shadow="true"] {
      ${smallShadow}
    }

    &[data-is-clickable="true"] {
      background: ${colors.grey15};
    }

    &[data-support-interaction="true"] {
      cursor: pointer;
    }
  }
`;

export const StyledMultiSelect = styled(MultiSelect)`
  width: fit-content;
  min-width: 300px;
`;

export const TagPrefix = styled.span`
  ${caption};
  color: ${colors.textSecondary};
  display: inline-flex;
  justify-content: center;
  align-items: center;
  flex-shrink: 0;
  gap: ${spacing.quarter};
`;
